import { useCallback, useEffect, useState } from 'react';
import { listNewslettersPagines } from '../request/NewsletterRequest';

export const LIGNES_PAR_PAGE = 10;

// Charge une page de la liste admin des newsletters (pagination, filtres et regroupement côté serveur).
// Chaque ligne reçue est convertie en { principal, versions } : la version principale est la première.
export function useNewslettersPagines(filtres, isGroupe, page) {
  const [lignes, setLignes] = useState([]);
  // null tant qu'aucune page n'a été reçue : la page affiche alors le chargement plein écran une seule fois.
  const [info, setInfo] = useState(null);
  const [isChargement, setIsChargement] = useState(true);
  const [loadError, setLoadError] = useState(null);

  const recharger = useCallback(async () => {
    setIsChargement(true);
    const response = await listNewslettersPagines(page, LIGNES_PAR_PAGE, filtres, isGroupe);
    setIsChargement(false);
    // Réponse inattendue (401, erreur serveur, corps sans data) : on l'affiche au lieu de rester sur le chargement.
    if (response?.status !== 200 || !Array.isArray(response.data?.data)) {
      setLoadError(new Error(response?.data?.message || 'Chargement des newsletters impossible'));
      return;
    }
    setLoadError(null);
    setLignes(response.data.data.map((versions) => ({ principal: versions[0], versions })));
    setInfo({ currentPage: response.data.currentPage, totalPages: response.data.totalPages });
  }, [filtres, isGroupe, page]);

  useEffect(() => { recharger(); }, [recharger]);

  return { lignes, info, isChargement, loadError, recharger };
}
